<template>
  <DossierOperationalBase :config="config" />
</template>

<script>
import DossierOperationalBase from "../../components/dossier/operational/DossierOperationalBase.vue";

export default {
  name: "WorkSchedule",
  components: { DossierOperationalBase },

  data() {
    return {
      config: {
        // Identificação do módulo
        moduleKey: "work-schedule",
        title: "Escala de Trabalho",
        subtitle:
          "Gerencie e organize as escalas de trabalho por setor e turno",
        icon: "fas fa-calendar-alt",
        itemName: "escala",
        addLabel: "Nova escala",
        namePlaceholder:
          'Ex: "Enfermagem Noturno", "Cuidadores Final de Semana"',

        // Texto explicativo no formulário
        explainer:
          "O Dossiê exibe somente a escala vigente na data atual. " +
          "Escalas futuras ficam cadastradas mas não aparecem até o início da vigência. " +
          "Escalas anteriores ficam no histórico interno.",

        // Opções de tipo
        typeOptions: [
          "Enfermagem",
          "Cuidadores",
          "Serviços Gerais",
          "Cozinha",
          "Administrativo",
          "Equipe Multidisciplinar",
          "Outros",
        ],

        // Permissões
        writePermission: "dossier_work_schedule",
        readPermission: "dossier_read",

        // Endpoints
        listEndpoint: "/rest-home/dossier/work-schedule",
        saveEndpoint: "/rest-home/dossier/work-schedule",
        uploadEndpoint: "/rest-home/dossier/work-schedule/upload",
        deleteEndpoint: "/rest-home/dossier/work-schedule",
      },
    };
  },
};
</script>